// Coloration syntaxique : Prism avec les seuls langages courants
import './prismManual';
import Prism from 'prismjs'; // inclut markup, css, clike et javascript
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-yaml';

const ALIASES = {
  js: 'javascript', javascript: 'javascript', jsx: 'javascript', mjs: 'javascript', cjs: 'javascript',
  ts: 'typescript', typescript: 'typescript', tsx: 'typescript',
  json: 'json', jsonc: 'json',
  py: 'python', python: 'python',
  sql: 'sql', postgresql: 'sql', mysql: 'sql', sqlite: 'sql',
  bash: 'bash', sh: 'bash', shell: 'bash', zsh: 'bash', console: 'bash',
  css: 'css',
  html: 'markup', xml: 'markup', svg: 'markup', markup: 'markup',
  yaml: 'yaml', yml: 'yaml',
};

export function resolveLanguage(language) {
  const key = String(language || '').toLowerCase();
  const name = ALIASES[key];
  return name && Prism.languages[name] ? name : null;
}

/** Jetons Prism du code (ou null si le langage n'est pas pris en charge). */
export function tokenize(code, language) {
  const name = resolveLanguage(language);
  return name ? Prism.tokenize(code, Prism.languages[name]) : null;
}
